/* eslint-disable no-prototype-builtins */

import Box from '@mui/material/Box'
import Typography from '@mui/material/Typography'
import TextField from '@mui/material/TextField'
import IconButton from '@mui/material/IconButton'
import Button from '@mui/material/Button'
import Modal from '@mui/material/Modal'

import { handleChange } from '../../../../helpers/globalHelpers'
import { standardErrorContainer } from '../../../../helpers/errors'
import { standardSpinner } from '../../../../helpers/spinners'

export const paymentDetailsJSX = (PaymentElement, paymentMethodString, handlePaymentElementChange, stripePaymentForm, setStripePaymentForm, paymentErrors, setPaymentErrors, loadingPayment) => {
  console.log('stripePaymentForm amount ->', stripePaymentForm.amount)
  return (
    <Box
      sx={{
        mt: 1, mb: 0,
        pt: 2, pb: paymentMethodString === 'card' ? 3 : 2,
        backgroundColor: 'whitesmoke',
        width: '100%',
        boxShadow: 3,
        borderRadius: '5px',
        display: 'flex', flexDirection: 'column', justifyContent: 'flex-start', alignItems: 'center',
      }}
    >
      <Typography
        sx={{
          mb: 2,
          fontWeight: 'bold',
          fontSize: '18',
        }}
      >
        Payment Method
      </Typography>

      {/* Card Information */}
      <Box 
        sx={{ 
          width: '95%',
          display: 'flex', flexDirection: 'column', justifyContent: 'flex-start', alignItems: 'center',
        }}
      >
        <Box 
          sx={{ 
            display: 'flex', flexDirection: 'column',
          }}
        >

          <PaymentElement 
            onChange={(e) => handlePaymentElementChange(e)} 
            options={{
              // paymentMethodOrder: ['apple_pay', 'google_pay'],
              terms: {
                googlePay: 'never',
                applePay: 'never',
                card: 'never',
              },
            }}
          />


          {(paymentMethodString === 'card') &&
            <>
              {/* Cardholder Name */}
              <Typography
                sx={{
                  mt: 1,
                  fontSize: '15px',
                  fontWeight: 400,
                  color: '#36454F',
                }}
              >
                Cardholder Name
              </Typography>

              <TextField
                focused={false}
                size={'small'}
                name={'cardholderName'}
                value={stripePaymentForm.cardholderName}
                onChange={(e) => handleChange(e, setPaymentErrors, setStripePaymentForm, stripePaymentForm)}
                sx={{
                  // mb: 1.5,
                  backgroundColor: 'white',
                }}
              />
            </>
          }


          {/* Promo Code */}
          {/* <Typography
            sx={{
              mt: 1.5,
              fontSize: '15px',
              fontWeight: 400,
              color: '#36454F',
            }}
          >
            Promo Code
          </Typography>

          <TextField
            focused={false}
            size={'small'}
            name={'promoCode'}
            value={stripePaymentForm.promoCode}
            onChange={(e) => handleChange(e, setPaymentErrors, setStripePaymentForm, stripePaymentForm)}
            sx={{
              // mb: 1.5,
              backgroundColor: 'white',
            }}
          /> */}


          {/* Payment Error */}
          {/* {console.log('paymentErrors ->', paymentErrors)} */}
          {Object.keys(paymentErrors).length > 0 &&
            standardErrorContainer(
              `${paymentErrors.hasOwnProperty('message') ? paymentErrors.message : 'Could not process payment. Try again with a different card.'}`,
              0,
              0
            )
          }
    
          {loadingPayment &&
            <Box
              sx={{
                width: '100%',
                minHeight: '100px',
                height: '100px',
                maxHeight: '100px',
                display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center',
              }}
            >
              {standardSpinner()}
            </Box>
          }

          {loadingPayment && 
            <Typography 
              component='pre'
              textAlign={'center'}
              sx={{
                mt: 2, mb: 2,
                width: '90%',
                fontStyle: 'italic',
                color: 'blue',
              }}
            >
              
              {
                `*Payment Processing 
                *Do not refresh or exit page`.replace(/ {4} +/g, '')
              }
                
            </Typography>
          }
        </Box> 
      </Box>
    </Box>
  )
}